module.exports = __webpack_public_path__ + "static/img/003-2.906f007e.png";